import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, FormControl, Input, InputLabel } from '@mui/material';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { Props } from './interface';
import {
  getUserAsync,
  updateUserBalanceAsync
} from '../../redux/slices/usersSlice';
import { InputChangeEvent } from '../../resources/utils';
import BonusBalanceConfirmationModal from './BonusBalanceConfirmationModal';

const PREFIX = 'UserBonusBalance';

const classes = {
  wrapper: `${PREFIX}-wrapper`,
  submit: `${PREFIX}-submit`,
  balance: `${PREFIX}-balance`,
  negative: `${PREFIX}-negative`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.wrapper}`]: {
    display: 'inline-flex',
    alignItems: 'flex-end'
  },

  [`& .${classes.submit}`]: {
    marginLeft: 20
  },

  [`& .${classes.balance}`]: {
    fontWeight: 600,
    color: theme.palette.primary.main
  },

  [`& .${classes.negative}`]: {
    color: theme.palette.error.main
  }
}));

const UserBonusBalance = ({ bonusPoints, margin, fullWidth, userId, onSave }: Props) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState('');
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const handleOpenConfirmModal = () => {
    if (!value || Number(value) === 0) return;
    setConfirmModalOpen(true);
  };

  const handleConfirm = (description: string) => {
    dispatch(
      updateUserBalanceAsync(
        userId,
        { 
          amount: 0, // Set to 0 to avoid changing regular balance
          bonusPointsAmount: Number(value), // Only modify bonus points
          description: description || undefined
        },
        () => {
          dispatch(getUserAsync(userId));

          if (onSave) {
            onSave();
          }

          setValue('');
        }
      )
    );
  };

  const isNegative = Number(value) < 0;

  return (
    <>
      <StyledFormControl fullWidth={fullWidth} margin={margin}>
        <div className={classes.wrapper}>
          <FormControl fullWidth>
            <InputLabel>
              Бонусний баланс (
              <span
                className={clsx(classes.balance, bonusPoints < 0 && classes.negative)}
              >
                {bonusPoints || 0}
              </span>
              )
            </InputLabel>
            <Input
              fullWidth={fullWidth}
              margin='none'
              type='number'
              value={value}
              onChange={(e: InputChangeEvent) => setValue(e.target.value)}
            />
          </FormControl>
          <Button 
            className={classes.submit} 
            color={isNegative ? 'error' : 'primary'} 
            variant={isNegative ? 'contained' : 'text'}
            onClick={handleOpenConfirmModal}
          >
            {isNegative ? 'Відняти' : 'Додати'}
          </Button>
        </div>
        <div />
      </StyledFormControl>

      <BonusBalanceConfirmationModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirm}
        amount={Number(value)}
        currentBalance={bonusPoints || 0}
      />
    </>
  );
};

export default UserBonusBalance;
